// On-the-fly creation of subjects/categories for combo editors.
//
// SearchableSelect with allowCreate emits `{ value: null, label, isNew: true }`
// when the user types a name that doesn't exist. These helpers POST the name
// to the backend (get-or-create) and resolve it into a real option
// `{ value: id, label }` so the rest of the form can treat it like any
// existing row.
import { api } from '../services/api';

// Category names accept the "Parent:Child" format; the backend creates the
// hierarchy level by level, reusing existing parents.
export const ensureSubject = async (name) => {
    const response = await api.post('/subjects', { name });
    return { value: response.data.id, label: response.data.name };
};

export const ensureCategory = async (name) => {
    const response = await api.post('/categories', { name });
    // Label as the full ancestor chain so nested picks read "Parent:Child".
    return { value: response.data.id, label: response.data.full_name || response.data.name };
};